module.exports = __webpack_public_path__ + "static/media/app_demandprediction.17c05ece.svg";